//Library Imports
import React, { useState, useEffect, useRef } from "react";
import { Select } from "antd";
import styled from "styled-components";

// Local Imports
import DropdownArrow from "../../../../assets/img/icons/dropdownarrow.svg";
import Checkbox from "../../../Common/Components/Checkbox";
import { IPERSONALITY_TYPES } from "../constants";

type FilterDropdownPersonalityProps = {
  selectedPersonalityType: string[];
  setSelectedPersonalityType: (value: string[]) => void;
};

const FilterDropdownPersonality: React.FC<FilterDropdownPersonalityProps> = (
  props: FilterDropdownPersonalityProps
) => {
  const { selectedPersonalityType, setSelectedPersonalityType } = props;

  // Local States
  const [openDropdown, setOpenDropdown] = useState(false);
  const selectRef = useRef<HTMLDivElement>(null);
  const customSelectRef = selectRef?.current;

  const stopClickEvent = (e: any) => {
    e.stopPropagation();
  };

  useEffect(() => {
    // bind click events on campaign dropdwon
    window.addEventListener(".campaigns-list click", function (e: any) {
      if (!customSelectRef?.contains(e.target)) {
        customSelectRef?.classList.remove("open");
      }
      console.log(customSelectRef);
    });

    // const allPersonalityTypesArray = IPERSONALITY_TYPES.map((personality) => {
    //   return personality.name;
    // });
    // setSelectedPersonalityType(allPersonalityTypesArray);

    return () => {
      window.removeEventListener("click", function (e: any) {
        if (!customSelectRef?.contains(e.target)) {
          customSelectRef?.classList.remove("open");
        }
        console.log(customSelectRef);
      });
    };
    // don't forget to remove the event listerners when the component unmounts
  }, []);

  const checkboxClickHandler = (checked: boolean, value: string) => {
    if (checked) {
      setSelectedPersonalityType([...selectedPersonalityType, value]);
    } else {
      setSelectedPersonalityType(selectedPersonalityType.filter((personality) => personality !== value));
    }
  };

  const selectAllClickHandler = (e: any) => {
    const allPersonalityTypesArray = IPERSONALITY_TYPES.map((personality) => {
      return personality.name;
    });
    setSelectedPersonalityType(allPersonalityTypesArray);
    stopClickEvent(e);
  };

  const unSelectAllClickHandler = (e: any) => {
    setSelectedPersonalityType([]);
    stopClickEvent(e);
  };

  return (
    <StyleWrapper selectedPersonalityType={selectedPersonalityType}>
      <div className="custom-select-wrapper" onClick={() => setOpenDropdown(!openDropdown)}>
        <div ref={selectRef} className={`campaigns-list custom-select ${openDropdown ? "open" : ""} `}>
          <div className="overlay-campaign-list"></div>
          <div className="custom-select__trigger">
            <span>{"Personality"}</span>
          </div>
          <div>
            <div className="arrow-dropdown">
              <img src={DropdownArrow} />
            </div>
          </div>

          <div onClick={(e) => stopClickEvent(e)} className="custom-options">
            <div className="search-field"></div>
            <span className="d-flex select-text-style">
              {selectedPersonalityType.length < 17 ? (
                <span className="green" onClick={selectAllClickHandler}>
                  Select All
                </span>
              ) : (
                <span className="green" onClick={unSelectAllClickHandler}>
                  Unselect All
                </span>
              )}
            </span>
            <ul
              onClick={(e) => stopClickEvent(e)}
              className="select-options padding-md scrollable scrollableCustom"
            >
              {IPERSONALITY_TYPES.map((item, index) => {
                return (
                  <li key={`${item?.name}-${item?.color}`}>
                    <Checkbox
                      onChange={() =>
                        checkboxClickHandler(!selectedPersonalityType.includes(item.name), item.name)
                      }
                      width="18px"
                      height="18px"
                      checked={selectedPersonalityType.indexOf(item.name) > -1}
                      value={item.name}
                    />
                    <Circle color={item.color} />
                    <span
                      onClick={() => checkboxClickHandler(!selectedPersonalityType.includes(item.name), item.name)}
                    >
                      {item.name}
                    </span>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </StyleWrapper>
  );
};

export default FilterDropdownPersonality;

const { Option } = Select;

const ArrowIcon = (
  <div
    style={{
      height: "22px",
      paddingLeft: "8px",
      paddingTop: "4px",
      paddingRight: "8px",
      borderLeft: "solid 1px #DDDDDD",
    }}
  >
    <img src={DropdownArrow} />
  </div>
);

const Circle = styled.div<{ color: string }>`
  display: inline-block;
  width: 10px;
  height: 10px;
  background: ${(props) => props.color};
  border-radius: 50%;
  margin-right: 5px;
`;

const StyleWrapper = styled.div<{ selectedPersonalityType: string[] }>`
  width: 100%;
  .disable {
    pointer-events: none;
  }
  .fetch-text {
    font-size: 12px;
    font-weight: 600;
    color: #5e7079;
  }
  .search-wraper {
    position: relative;
    width: 100%;
    .search-results {
      border-radius: 22px;
      position: absolute;
      top: -80px;
      left: 0;
      // display: none;
      float: left;

      width: 100%;
      border: 1px solid #dadada;
      box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.12);
      overflow: hidden;
      transition: 0.5s;
      z-index: -1;
      opacity: 0;
      visibility: hidden;
      &.show {
        opacity: 1;
        z-index: 1;
        visibility: visible;
      }
      ul.results-list {
        background: #fff;
        padding: 30px 55px 10px 55px;
        margin: 0;
        list-style: none;
        float: left;
        display: block;
        width: 100%;
        transition: 0.5s;
        li {
          color: #5e7079;
          font-size: 16px;
          line-height: 34px;
          padding: 0;
          list-style: none;
          float: left;
          width: 100%;
          display: block;
          /* cursor: pointer; */
          transition: 0.5s;
        }
      }
      .relevant-theme,
      .relevant-company {
        border-top: 1px solid #dadada;
        padding: 10px 40px 30px 40px;
        background: #f7f7f7;
        float: left;
        width: 100%;
        transition: 0.5s;
        h3 {
          margin-bottom: 10px;
          color: #424b50;
          font-weight: 400;
          font-family: "Roboto Slab", serif;
          font-size: 18px;
          line-height: 34px;
        }
      }
      .search-hint {
        background: #def6e6;
        padding: 18px 25px 36px 25px;
        border-radius: 22px 22px 0 0;
        float: left;
        width: 100%;
        svg {
          float: left;
          width: 35px;
          height: 39px;
        }
        ul {
          margin: 0;
          float: left;
          li {
            color: #09a43a;
            font-size: 14px;
            font-weight: 400;
            list-style: none;
            strong {
              font-weight: 700;
            }
          }
        }
      }
    }
    .search-bar {
      border-radius: 27px;
      background: #ffffff;
      border: 1px solid #dadada;
      display: block;
      float: left;
      width: 100%;
      overflow: hidden;
      position: relative;
      span.clear-search {
        float: right;
        margin-top: 5px;
        margin-right: 12px;
        transition: 0.5s;
        cursor: pointer;
        width: auto;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          margin-top: 3px;
          margin-right: 8px;
        }
        svg {
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            width: 10px;
          }
        }
      }
      span.refresh-search {
        padding-right: 5px;
        border-right: 1px solid #dadada;
        margin: 6px 8px;
        float: left;
        cursor: pointer;
        width: auto;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          margin: 3px 7px 3px 7px;
          line-height: 12px;
        }
        svg {
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            width: 10px;
          }
        }
        svg path {
          fill: #424b50;
        }
      }
      .search-input {
        float: left;
        border: none;
        outline: none;
        width: calc(100% - 90px);
        display: block;
        color: #424b50;
        font-weight: 400;
        font-size: 14px;
        margin-top: 3px;
        margin-bottom: 2px;
        font-family: "robotoregular";
        -webkit-box-shadow: 0 0 0 30px white inset !important;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 10px;
          margin-top: 3px;
        }
        &::-webkit-input-placeholder {
          font-family: "robotothin_italic";
          color: #c1c1c1;
        }
        &:-moz-placeholder {
          font-family: "robotothin_italic";
          color: #c1c1c1;
        }
        &::-moz-placeholder {
          font-family: "robotothin_italic";
          color: #c1c1c1;
        }
        &:-ms-input-placeholder {
          font-family: "robotothin_italic";
          color: #c1c1c1;
        }
        &:hover,
        &:active,
        &:focus {
          border: none;
          outline: none;
        }
      }
    }
  }
  .scrollableCustom {
    overflow: scroll;
    /* height: 110px; */
    overflow-x: hidden;
    /* @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      height: 110px;
    } */
    scrollbar-width: thin;
    scrollbar-color: #001760 transparent;
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
      border-radius: 5px;
    }
    /* Track */
    &::-webkit-scrollbar-track {
      background: #fff;
      margin-top: 10px;
      margin-bottom: 15px;
    }
    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: #001760;
    }
    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }
  .assetInput {
    width: 100%;
    border: solid 1px #dadada;
    padding: 5px 12px;
    font-size: 16px;
    color: #7e7e7e;
    font-family: "robotomedium", sans-serif;
    border-radius: 8px;
    &:focus,
    &:active {
      outline: none;
    }
  }
  .custom-select-wrapper {
    position: relative;
    user-select: none;
    width: 100%;
  }
  .custom-select {
    position: relative;
    display: flex;
    flex-direction: column;
    border-width: 0;
    border-style: solid;
  }
  .custom-select__trigger {
    position: relative;
    /* display: flex; */
    /* align-items: center;
    justify-content: space-between; */
    /* padding: 0 22px 10px 22px; */
    height: 36px;
    line-height: 28px;
    background: ${(props) => (props.selectedPersonalityType.length > 0 ? "#def6e6" : "#ffffff")};
    cursor: pointer;
    border: solid 1px #dadada;
    padding: 3px 35px 3px 15px;
    font-size: 16px;
    color: ${(props) => (props.selectedPersonalityType.length > 0 ? "#09a43a" : "#7e7e7e")};
    font-family: "robotomedium", sans-serif;
    border-radius: 8px;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 12px;
      padding: 7px 35px 7px 10px;
      line-height: 12px;
      height: 30px;
      border-radius: 6px;
    }
    span {
      overflow: hidden;
      width: 100%;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .arrow-dropdown {
    position: absolute;
    top: 8px;
    right: 4px;
    height: 22px;
    padding-left: 8px;
    padding-top: 0;
    padding-right: 8px;
    border-left: solid 1px #dddddd;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      top: 7px;
      height: 15px;
      line-height: 14px;
    }
  }
  .custom-options {
    background-color: #fff;
    position: absolute;
    display: block;
    top: 120%;
    left: 0;
    right: 0;
    background: #fff;
    /* transition: all 0.5s; */
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    z-index: 999;
    border-radius: 8px;
    border: solid 1px #dadada;
    padding-bottom: 1em;
    box-shadow: 0px 0px 28px rgba(0, 0, 0, 0.28);
    /* @media all and (max-height: 850px) {
      top: auto;
      bottom: calc(100% + 5px);
    } */
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      border-radius: 6px;
    }
    .select-text-style {
      padding-left: 10px;
      font-size: 16px;
      font-weight: 500;
      font-family: "Roboto", sans-serif;
      .grey {
        color: #c1c1c1;
        cursor: pointer;
      }
      .green {
        color: #1ec252;
        cursor: pointer;
      }
    }
    .search-field {
      display: flex;
      flex: 1;
      background-color: #fff;
      border-radius: 8px;
      margin-top: 10px;
    }
    .new-campaign {
      border-top: 1px solid #dadada;
      border-bottom: 1px solid #dadada;
      cursor: pointer;
      h3 {
        margin: 0;
        font-size: 16px;
        color: #7e7e7e;
        font-family: "robotomedium", sans-serif;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 12px;
        }
      }
    }
    .select-options {
      list-style-type: none;
      margin: 0;
      padding: 5px 10px 0px 10px;
      max-height: 370px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        max-height: 320px;
      }
      li {
        font-family: "robotomedium", sans-serif;
        font-size: 16px;
        color: #7e7e7e;
        /* cursor: pointer; */
        transition: 0.5s;
        /* width: 460px; */
        /* width: calc(100% - 5px); */
        display: block;
        align-items: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 2;
        &:hover {
          /* margin-left: 5px;
          transition: 0.5s; */
          color: #27ce0a;
          cursor: pointer;
        }
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          /* font-size: 12px; */
        }
      }
    }
  }
  .custom-select.open .custom-options {
    opacity: 1;
    visibility: visible;
    pointer-events: all;
    width: 180%;
    padding: 5px 10px 10px 10px;
  }
  .custom-option {
    position: relative;
    display: block;
    font-size: 22px;
    font-weight: 300;
    color: #3b3b3b;
    line-height: 60px;
    /* cursor: pointer; */
    transition: all 0.5s;
  }
  .custom-option:hover {
    /* cursor: pointer; */
    /* background-color: #b2b2b2; */
  }
  .custom-option.selected {
    color: #ffffff;
    background-color: #305c91;
  }

  .arrow {
    position: relative;
    height: 15px;
    width: 15px;
  }
  .arrow::before,
  .arrow::after {
    content: "";
    position: absolute;
    bottom: 0px;
    width: 0.15rem;
    height: 100%;
    transition: all 0.5s;
  }
  .arrow::before {
    left: -5px;
    transform: rotate(45deg);
    background-color: #394a6d;
  }
  .arrow::after {
    left: 5px;
    transform: rotate(-45deg);
    background-color: #394a6d;
  }
  .open .arrow::before {
    left: -5px;
    transform: rotate(-45deg);
  }
  .open .arrow::after {
    left: 5px;
    transform: rotate(45deg);
  }
  .overlay-campaign-list {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100vw;
    height: 100vh;
    z-index: -999;
  }
  .open {
    .overlay-campaign-list {
      z-index: 15;
    }
  }
`;
